import { render, staticRenderFns } from "./LeaveBalanceAdjEdit.vue?vue&type=template&id=63250a37"
import script from "./LeaveBalanceAdjEdit.vue?vue&type=script&lang=js"
export * from "./LeaveBalanceAdjEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports